import {
  type IConsumer,
  type IEvent,
  type TSubscriberHandler,
  createConsumer,
  createSubscriber,
} from '@cian/events-log';

import { useCallback, useEffect } from 'react';

import { MICROFRONTEND_NAME } from '../constants';
import { type IStationData } from '../types';

let consumer: IConsumer;

export function useUndergroundMapEventsToActions(updateCb: (stations: IStationData[]) => void): void {
  const subscribeHandler = useCallback(
    (event: IEvent<IStationData[]>) => {
      if (event.type === 'selected-stations-change') {
        updateCb(event.value);
      }
    },
    [updateCb],
  );

  const effectHandler = useCallback(() => {
    consumer ??= createConsumer({ topic: MICROFRONTEND_NAME });

    const complaintsSubscriber = createSubscriber(subscribeHandler as TSubscriberHandler);

    consumer.subscribe(complaintsSubscriber);

    return () => {
      consumer.unsubscribe(complaintsSubscriber);
    };
  }, [subscribeHandler]);

  useEffect(() => {
    const clear = effectHandler();

    return clear;
  }, [effectHandler]);
}
